export enum ProcedureCodes {
    Initial = 'Initial',
    Supplemental = 'Supplemental'
}